/**
 * Returns a background style object for hero components, supporting mobile-specific images and gradients.
 */
export function getHeroBgStyle({
    backgroundType,
    backgroundImage,
    backgroundImageMobile,
    backgroundColor,
    backgroundGradient,
    isMobile,
    isBuilderMobile
}: {
    backgroundType: string | undefined
    backgroundImage?: string
    backgroundImageMobile?: string
    backgroundColor?: string
    backgroundGradient?: string
    isMobile: boolean
    isBuilderMobile: boolean
}): React.CSSProperties {
    if (backgroundType === 'image') {
        if ((isMobile || isBuilderMobile) && backgroundImageMobile) {
            return {
                backgroundImage: `url(${backgroundImageMobile})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }
        } else if (backgroundImage) {
            return {
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }
        }
    } else if (backgroundType === 'color' && backgroundColor) {
        return {backgroundColor}
    } else if (backgroundType === 'gradient' && backgroundGradient) {
        return {
            background: backgroundGradient,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
    }
    return {}
}
